export default __webpack_public_path__ + "static/media/pos-deactive.beeb8808.svg";